import { Injectable } from '@angular/core';
import { IntacctDepartmentDto } from './dto/intacct-department.dto';
import { IntacctLocationDto } from './dto/intacct-location.dto';
import { IntacctJournalDto } from './dto/intacct-journal.dto';
import { FinancialApiService } from 'src/app/revenue/shared/financial-api.service';
import { IntacctDepartmentSearchDto } from './dto/intacct-department-search.dto';
import { IntacctLocationSearchDto } from './dto/intacct-location-search.dto';
import { PagedResultGeneric } from 'src/app/shared';
import { IntacctJournalSearchDto } from './dto/intacct-journal-search.dto';
@Injectable({
  providedIn: 'root',
})
export class IntacctService {
  public constructor(private _apiService: FinancialApiService) {}

  // Departments
  public searchIntacctDepartments(seachParams: IntacctDepartmentSearchDto): Promise<PagedResultGeneric<IntacctDepartmentDto>> {
    return this._apiService.post('/financial/v2/intacct/departments', seachParams);
  }

  public getIntacctDepartment(intacctDepartmentId: number) {
    return this._apiService.get(`/financial/v2/intacct/department/${intacctDepartmentId}`);
  }

  public createIntacctDepartment(intacctDepartment: IntacctDepartmentDto) {
    return this._apiService.post('/financial/v2/intacct/department', intacctDepartment);
  }

  public updateIntacctDepartment(intacctDepartment: IntacctDepartmentDto) {
    return this._apiService.put(`/financial/v2/intacct/department`, intacctDepartment);
  }

  public deleteIntacctDepartment(intacctDepartmentId: number) {
    return this._apiService.delete(`/financial/v2/intacct/department/${intacctDepartmentId}`);
  }

  // Locations
  public searchIntacctLocations(seachParams: IntacctLocationSearchDto): Promise<PagedResultGeneric<IntacctLocationDto>> {
    return this._apiService.post('/financial/v2/intacct/locations', seachParams);
  }

  public getIntacctLocation(intacctLocationId: number) {
    return this._apiService.get(`/financial/v2/intacct/location/${intacctLocationId}`);
  }

  public createIntacctLocation(intacctLocation: IntacctLocationDto) {
    return this._apiService.post('/financial/v2/intacct/location', intacctLocation);
  }

  public updateIntacctLocation(intacctLocation: IntacctLocationDto) {
    return this._apiService.put(`/financial/v2/intacct/location`, intacctLocation);
  }

  public deleteIntacctLocation(intacctLocationId: number) {
    return this._apiService.delete(`/financial/v2/intacct/location/${intacctLocationId}`);
  }

  // Journals
  public searchIntacctJournals(seachParams: IntacctJournalSearchDto): Promise<PagedResultGeneric<IntacctJournalDto>> {
    return this._apiService.post('/financial/v2/intacct/journals', seachParams);
  }

  public getIntacctJournal(intacctJournalId: number) {
    return this._apiService.get(`/financial/v2/intacct/journal/${intacctJournalId}`);
  }

  public createIntacctJournal(intacctJournal: IntacctJournalDto) {
    return this._apiService.post('/financial/v2/intacct/journal', intacctJournal);
  }

  public updateIntacctJournal(intacctJournal: IntacctJournalDto) {
    return this._apiService.put(`/financial/v2/intacct/journal`, intacctJournal);
  }

  public deleteIntacctJournal(intacctJournalId: number) {
    return this._apiService.delete(`/financial/v2/intacct/journal/${intacctJournalId}`);
  }
}
